import { useState, useRef } from "react";

const dateFormats = [
  {
    label: "Local Date",
    calc: (date: Date) => {
      return date.toLocaleDateString();
    },
  },
  {
    label: "Local Time",
    calc: (date: Date) => {
      return date.toLocaleTimeString();
    },
  },
  {
    label: "Local Date and Time",
    calc: (date: Date) => {
      return date.toLocaleString();
    },
  },
  {
    label: "ISO",
    calc: (date: Date) => {
      return date.toISOString();
    },
  },
];

const board = window.miro.board;

export default function DateTime() {
  const [whens, setWhens] = useState<{ label: string; value: string }[]>(
    calcWhens([])
  );
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");
  const content = useRef<HTMLInputElement>(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  const dateTimeTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-text cs3"></div>
    </div>
  );

  async function handleFormatClick(event: React.MouseEvent<HTMLButtonElement>) {
    const index = parseInt(
      event.currentTarget.getAttribute("data-index") || ""
    );
    const miroSelection = (await miro.board.getSelection()) as any[];
    const now = new Date();
    for (const item of miroSelection) {
      if (item.content !== undefined) {
        item.content = dateFormats[index].calc(now);
        await item.sync();
      }
    }
  }

  function calcWhens(oldWhens: { label: string; value: string }[] = whens) {
    const newWhens = [...oldWhens];
    const now = new Date();
    dateFormats.forEach((format, index) => {
      const newValue = format.calc(now);
      if (newValue !== newWhens[index]?.value) {
        newWhens[index] = { label: format.label, value: newValue };
      }
    });
    return newWhens;
  }

  // useEffect(() => {
  //     const id = setInterval(() => {
  //         setWhens(
  //             (oldWhens) => { return calcWhens(oldWhens); }
  //         )
  //     }, 97);
  //     return () => {
  //         clearTimeout(id)
  //     }
  // }, [])

  return (
    <div
      id="instert-date-and-time-tool"
      className="grid tool-section mt-0 pb-0">
      <div
        id="instert-date-and-time-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 icon m2 icon-timer mt-0 mb-0"></div>
        <h3 className="h3 cs2 ce11 mt-0 mb-0">Insert Date & Time</h3>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <div
            id="lorem-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on
              <b> many:</b>
            </p>
            {dateTimeTypeIcons}
          </div>
          {/*  */}
          {whens.map((when, index) => (
            <button
              onClick={handleFormatClick}
              data-index={index}
              key={when.label}
              style={{ textAlign: "left" }}
              type="button"
              className="button button-secondary fix-button-secondary button-small cs1 ce12 mt-0 mb-0 mr-0">
              <b>{when.label}</b> : {when.value}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
